// src/app/components/custom-loader/custom-loader.component.ts
import { Component } from '@angular/core';
import { GlobalLoaderService } from '../../services/global-loader.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss'],
})
export class CustomLoaderComponent {
  isLoading$: Observable<boolean>;

  constructor(
    private globalLoaderService: GlobalLoaderService
  ) {
    this.isLoading$ = this.globalLoaderService.isLoading$;
  }
}